var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: 1200, "footer-hide": true, title: "预发货单" },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          ref: "deliveryForm",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .preSaleOrderRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单编号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员名称" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressContacts,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "会员电话" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressPhone,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单状态" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordOrderStatus,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "本定单合计" } },
                                    [
                                      _c("currency-input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordTotalOrderCost,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "收货地址" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.deliveryAddressFull,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "发货日期",
                                        prop: "preSaleDeliveryRecordDeliveryDate",
                                      },
                                    },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          value:
                                            _vm.deliveryTable.form
                                              .preSaleDeliveryRecordDeliveryDate,
                                          options: _vm.deliveryDateOptions,
                                          type: "date",
                                          format: "yyyy-MM-dd",
                                        },
                                        on: {
                                          "on-change": _vm.onDeliveryDateChange,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "7" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "备注" } },
                                    [
                                      _c("Input", {
                                        model: {
                                          value:
                                            _vm.deliveryTable.form
                                              .preSaleDeliveryRecordRemark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.deliveryTable.form,
                                              "preSaleDeliveryRecordRemark",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "deliveryTable.form.preSaleDeliveryRecordRemark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: " " } },
                                    [
                                      _c(
                                        "Button",
                                        {
                                          attrs: { type: "success" },
                                          on: { click: _vm.onSubmit },
                                        },
                                        [
                                          _vm._v(
                                            "提交预发货单\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v("定单商品")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "300px",
                                            "margin-bottom": "4px",
                                          },
                                        },
                                        [
                                          _c(
                                            "Checkbox",
                                            {
                                              on: {
                                                "on-change":
                                                  _vm.onEnablePromotion,
                                              },
                                              model: {
                                                value:
                                                  _vm.enableManualPromotion,
                                                callback: function ($$v) {
                                                  _vm.enableManualPromotion =
                                                    $$v
                                                },
                                                expression:
                                                  "enableManualPromotion",
                                              },
                                            },
                                            [_vm._v("启用人工优惠")]
                                          ),
                                          _c(
                                            "Select",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                                width: "180px",
                                              },
                                              attrs: {
                                                size: "small",
                                                disabled:
                                                  _vm.enableManualPromotion ===
                                                  false,
                                              },
                                              on: {
                                                "on-change":
                                                  _vm.onPromotionChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedManualPromotionUuid,
                                                callback: function ($$v) {
                                                  _vm.selectedManualPromotionUuid =
                                                    $$v
                                                },
                                                expression:
                                                  "selectedManualPromotionUuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.manualPromotionList,
                                              function (promotion) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: promotion.seedFarmManualPromotionUuid,
                                                    attrs: {
                                                      value:
                                                        promotion.seedFarmManualPromotionUuid,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        promotion.seedFarmManualPromotionName +
                                                          "，优惠:" +
                                                          promotion.seedFarmManualPromotionDiscount
                                                      ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("Table", {
                                    ref: "mainTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.orderDetail.columns,
                                      data: _vm.orderDetail.rows,
                                      height: 200,
                                      stripe: "",
                                      border: "",
                                    },
                                    on: {
                                      "on-select": _vm.onRowSelect,
                                      "on-select-cancel": _vm.onRowSelectCancel,
                                      "on-select-all": _vm.onSelectAll,
                                      "on-select-all-cancel":
                                        _vm.onSelectAllCancel,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v("本次发货商品")]),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              "font-size": "16px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "合计发货量:" +
                                                _vm._s(
                                                  _vm.deliveryTable
                                                    .totalQuantity
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              "font-size": "16px",
                                              "margin-left": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "合计发货金额:" +
                                                _vm._s(
                                                  _vm.numberToFixed(
                                                    _vm.deliveryTable
                                                      .totalValue,
                                                    2
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("Table", {
                                    ref: "deliveryTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.deliveryTable.columns,
                                      data: _vm.deliveryTable.rows,
                                      height: 200,
                                      stripe: "",
                                      border: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Modal",
                {
                  attrs: { title: `请填写预发货的数量`, width: "75" },
                  on: { "on-ok": _vm.onAddProducts },
                  model: {
                    value: _vm.warehouseModal.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.warehouseModal, "show", $$v)
                    },
                    expression: "warehouseModal.show",
                  },
                },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("Table", {
                            ref: "warehouseTable",
                            attrs: {
                              size: "small",
                              columns:
                                _vm.warehouseModal.warehouseTable.columns,
                              data: _vm.warehouseModal.warehouseTable.rows,
                              stripe: "",
                              border: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "right",
                            "margin-right": "10px",
                            "marign-top": "10px",
                            "font-size": "16px",
                          },
                        },
                        [
                          _vm._v(
                            "发货总量: " +
                              _vm._s(
                                _vm.warehouseModal.warehouseTable.totalQuantity
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "修改产品缓冲设置" },
          on: { "on-ok": _vm.onUpdateBuffer },
          model: {
            value: _vm.bufferEditModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.bufferEditModal, "show", $$v)
            },
            expression: "bufferEditModal.show",
          },
        },
        [
          _c(
            "Form",
            {
              staticClass: "form-input-no-outline",
              attrs: { "label-position": "top" },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "预售发货缓冲天数（天）" } },
                        [
                          _c("integer-input", {
                            attrs: { min: 0, max: 100 },
                            model: {
                              value:
                                _vm.bufferEditModal.form
                                  .preSaleOrderDetailDeliveryDayBuffer,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.bufferEditModal.form,
                                  "preSaleOrderDetailDeliveryDayBuffer",
                                  $$v
                                )
                              },
                              expression:
                                "bufferEditModal.form.preSaleOrderDetailDeliveryDayBuffer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "预售发货缓冲量（%））" } },
                        [
                          _c("integer-input", {
                            attrs: { min: 0, max: 100 },
                            model: {
                              value:
                                _vm.bufferEditModal.form
                                  .preSaleOrderDetailDeliveryQuantityBuffer,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.bufferEditModal.form,
                                  "preSaleOrderDetailDeliveryQuantityBuffer",
                                  $$v
                                )
                              },
                              expression:
                                "bufferEditModal.form.preSaleOrderDetailDeliveryQuantityBuffer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }